module.exports = __webpack_public_path__ + "img/ps.68f88c5c.png";